import { ICONO, type Icono } from '../ui/iconos.js';

/**
 * El eco de la respuesta (echo): confirma lo que el paciente tocó antes de
 * avanzar.
 *
 * Para un adulto mayor con el teléfono en una mano, ver escrito "Tu respuesta: 3"
 * evita avanzar con un toque errado. Es una región `aria-live="polite"`: cuando
 * cambia la respuesta, el lector de pantalla la anuncia sin interrumpir.
 *
 * Sin respuesta todavía no se dibuja: un eco vacío invita a pensar que ya se
 * eligió algo.
 *
 * **El rótulo arriba y la respuesta abajo** (devolución del 04/10): al lado de
 * las opciones, una persona mayor tiene que leerlo como un bloque aparte, y una
 * respuesta larga no puede quedar apretada a la derecha. El bloque mide casi lo
 * mismo que la fila de antes: con el título y la pregunta más largos, el botón
 * "Siguiente" tiene que seguir a la vista sin scroll (la captura
 * `P-05-titulo-y-pregunta-largos` lo verifica), y no queda lugar para sumar
 * margen alrededor. La separación de las opciones es la de siempre.
 */
export function EcoDeRespuesta({
  etiqueta,
  valor,
  icono: IconoDelEco,
}: {
  etiqueta: string;
  valor: string | null;
  icono?: Icono | undefined;
}) {
  return (
    <div aria-live="polite">
      {valor === null ? null : (
        <p className="m-0 flex items-center gap-4 rounded-lg bg-brand-soft px-5 py-2.5 text-heading">
          {IconoDelEco ? (
            <span
              aria-hidden="true"
              className="flex size-11 shrink-0 items-center justify-center rounded-full bg-card text-link"
            >
              <IconoDelEco className={ICONO.normal} />
            </span>
          ) : null}
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="text-base leading-tight font-medium">{etiqueta}</span>
            <span className="font-serif text-display-sm leading-tight break-words text-link">
              {valor}
            </span>
          </span>
        </p>
      )}
    </div>
  );
}
